import { UIHeading3 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import * as styles from './DailyrentReviewsHeaderContainer.css';
import { getObjectInfo } from '../../selectors/objectInfo';

export const DailyrentReviewsHeaderContainer = () => {
  const objectInfo = useSelector(getObjectInfo);

  if (!objectInfo.reviewsCountText) {
    return null;
  }

  return (
    <section className={styles['root']}>
      <header>
        <UIHeading3 as="p">{objectInfo.reviewsCountText}</UIHeading3>
      </header>
    </section>
  );
};
